import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import React, { useEffect, useMemo } from "react";
import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import { useFormContext } from "react-hook-form";
import {
  useEquipment,
  useTypesUnits,
  useUser,
} from "@services/servicesGenericsTables";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import { InputAdornment } from "@mui/material";

const PreparationGTIG = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const { typesUnitsis } = useTypesUnits();
  const filteredProcedures = useFilteredProcedures("PRE");

  const { currentPreparation } = useAnalysis();

  const watchPlanchette = form.watch("planchette");
  const watchPlanchetteWithPrecipitate = form.watch(
    "planchette_with_precipitate"
  );

  const countingEquipment = useMemo(
    () => form.watch("analysis_equipment"),
    [form]
  );

  useEffect(() => {
    if (watchPlanchette && watchPlanchetteWithPrecipitate) {
      const result = watchPlanchetteWithPrecipitate - watchPlanchette;
      form.setValue("mg_torta", result);
    }
  }, [watchPlanchette, watchPlanchetteWithPrecipitate]);

  useEffect(() => {
    if (countingEquipment) {
      const lastGeometryEquipment = countingEquipment
        .filter((e) => e.is_geometry)
        .pop();

      if (lastGeometryEquipment && lastGeometryEquipment.height !== null) {
        form.setValue(
          "preparation_geometry_height",
          lastGeometryEquipment.height
        );
      } else {
        form.setValue("preparation_geometry_height", "");
      }
    }
  }, [countingEquipment, form]);

  return (
    <>
      {currentPreparation.index !== undefined && (
        <ResponsiveFormContainer columns={5}>
          <MAutocomplete
            key={JSON.stringify(form.getValues("analysis_analyst"))}
            name="analysis_analyst"
            options={userList}
            label="Seleccione un analista"
            getOptionLabel={(option) => option.username || ""}
            validation={{ required: "El analista es requerido" }}
            disabled={!currentPreparation.canEdit}
          />

          <MAutocomplete
            key={JSON.stringify(form.getValues("preparation_procedure"))}
            name="preparation_procedure"
            options={filteredProcedures}
            label="Procedimiento MLPMA"
            getOptionLabel={(option) => `${option.numop}` || ""}
            //validation={{ required: "El procedimiento es requerido" }}
            disabled={!currentPreparation.canEdit}
          />

          <MDatePicker
            name="start_date"
            pickerType="datetime"
            label="Fecha y hora de inicio"
            validation={{
              required: "La fecha es requerida",
            }}
            disabled={!currentPreparation.canEdit}
          />

          <MAutocomplete
            key={JSON.stringify(form.getValues("analysis_equipment"))}
            name="analysis_equipment"
            options={equipmentList}
            label="Equipos y geometrías"
              getOptionLabel={(option) =>
                `${option.codigo} - ${
                option.is_geometry 
                  ? (option.height || option.descripcion) 
                  : option.descripcion
              }` || ""
              }
            validation={{ required: "El equipo es requerido" }}
            multiple={true}
            disabled={!currentPreparation.canEdit}
          />

          <MTextField
            name="planchette"
            placeholder={"Tara geometría"}
            label={"Tara geometría"}
            type="number"
            validation={{ required: "La geometría es requerida" }}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">{"(g)"}</InputAdornment>
              ),
            }}
            disabled={!currentPreparation.canEdit}
          />
          <MTextField
            name="planchette_with_precipitate"
            placeholder={"Peso muestra + geometría"}
            label={"Peso muestra + geometría"}
            type="number"
            validation={{
              required: "El peso de la muestra + geometría es requerido",
            }}
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">{"(g)"}</InputAdornment>
              ),
            }}
            disabled={!currentPreparation.canEdit}
          />
          <MTextField
            name="mg_torta"
            placeholder="Peso muestra"
            label="Peso muestra"
            type="number"
            fullWidth
            disabled
          />
          <MTextField
            key={JSON.stringify(form.getValues("analysis_amount_sample"))}
            name="analysis_amount_sample"
            placeholder="Cantidad de muestra"
            label="Cantidad de muestra"
            type="number"
            validation={{ required: "La cantidad de muestra es requerida" }}
            fullWidth
            disabled={!currentPreparation.canEdit}
          />

          <MAutocomplete
            key={JSON.stringify(form.getValues("analysis_unit_types"))}
            name="analysis_unit_types"
            options={typesUnitsis}
            label="Seleccione un tipo de unidad"
            getOptionLabel={(option) =>
              `${option.codigo} | ${option.descripcion}`
            }
            validation={{ required: "El tipo de unidad es requerido" }}
            disabled={!currentPreparation.canEdit}
          />
          <MTextField
            key={"valid_preparation"}
            name="valid_preparation"
            placeholder="Preparación Válida"
            label="Preparación Válida"
            fullWidth
            disabled
          />
        </ResponsiveFormContainer>
      )}
    </>
  );
};

export default PreparationGTIG;
